import React from 'react';
import { Page } from './page';

import { Redirect } from "react-router-dom";

import Player from '../functions/player';
import API from '../functions/api';

var playerDistributionArray = [
  [2,	2,	2,	2,	2,	2,	1,	1,	"docent"],
  [2,	2,	2,	2,	2,	2,	1,	1,	1],
  [2,	2,	2,	2,	2,	2,	1,	2,	1],
  [2,	2,	2,	2,	2,	2,	2,	2,	1],
  [2,	2,	3,	2,	2,	2,	2,	2,	1],
  [2,	2,	3,	3,	2,	2,	2,	2,	1],
  [2,	2,	3,	3,	3,	2,	2,	2,	1],
  [2,	2,	3,	3,	3,	3,	2,	2,	1],
  [3,	2,	3,	3,	3,	3,	2,	2,	1],
  [3,	3,	3,	3,	3,	3,	2,	2,	1],
  [3,	3,	3,	3,	3,	3,	2,	3,	1],
  [3,	3,	3,	3,	3,	3,	3,	3,	1],
  [3,	3,	4,	3,	3,	3,	3,	3,	1],
  [3,	3,	4,	4,	3,	3,	3,	3,	1],
  [3,	3,	4,	4,	4,	3,	3,	3,	1],
  [3,	3,	4,	4,	4,	4,	3,	3,	1],
  [4,	3,	4,	4,	4,	4,	3,	3,	1],
  [4,	4,	4,	4,	4,	4,	3,	3,	1],
  [4,	4,	5,	4,	4,	4,	3,	3,	1],
  [4,	4,	5,	5,	4,	4,	3,	3,	1],
  [4,	4,	5,	5,	5,	4,	3,	3,	1],
  [4,	4,	5,	5,	5,	5,	3,	3,	1],
  [4,	4,	5,	5,	5,	5,	3,	4,	1],
];


var timeDistributionArray = [
  [80,  2, 14, 4, 12, 2, 3, 3, 12, 2, 3, 3, 12, 8],
  [85,  2, 14, 4, 14, 2, 3, 3, 13, 2, 3, 3, 14, 8],
  [90,  2, 14, 4, 16, 2, 3, 3, 15, 2, 3, 3, 15, 8],
  [95,  2, 14, 4, 17, 2, 3, 3, 17, 2, 3, 3, 17, 8],
  [100, 2, 14, 4, 19, 2, 3, 3, 18, 2, 3, 3, 19, 8],
  [105, 2, 14, 4, 21, 2, 3, 3, 20, 2, 3, 3, 20, 8],
  [110, 2, 14, 4, 22, 2, 3, 3, 22, 2, 3, 3, 22, 8],
  [115, 2, 14, 4, 24, 2, 3, 3, 23, 2, 3, 3, 24, 8],
  [120, 2, 14, 4, 26, 2, 3, 3, 25, 2, 3, 3, 25, 8],
  [125, 2, 14, 4, 27, 2, 3, 3, 27, 2, 3, 3, 27, 8],
  [130, 2, 14, 4, 29, 2, 3, 3, 28, 2, 3, 3, 29, 8],
];

export class PlayerRegistration extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      screenID: 0,
      mailAdres: '',
      fireRedirect: false,
      amount: '16',
      timerOver: false,
      persons: [],
      time_distribution: [80, 2, 14, 4, 12, 2, 3, 3, 12, 2, 3, 3, 12, 8],
      player_distribution: [2, 2, 2, 2, 2, 2, 2, 2],
      mail_adres: '',
      className: '',
      duration: 80,
      playerAmount: 16,
      sessionCode: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleValidation(user) {
    let valid = true;
    let errors = {};

    if (!user.name) {
      valid = false;
      errors['name'] = 'Geef een geldig email op;';
    }

    if (!user.roundLengths) {
      valid = false;
      errors['round_lengths'] = 'Geef op hoelang je wil spelen;';
    }

    if (!user.playerCount) {
      valid = false;
      errors['player_count'] = 'Geef op met hoeveel hoeveel spelers er zijn;'
    }

    if (!user.className) {
      valid = false;
      errors['class_name'] = 'Geef een naam op van je klas;';
    }

    this.setState({
      formErrors: errors,
      showError: true,
    })

    return valid;
  }

  handleCodeChange = (e) => {
    const target = e.target
    const value = target.type === 'checkbox' ? target.checked : target.value

    this.setState({
      oldSessionCode: value
    });
  }

  handleResume = (e) => {
    e.preventDefault();
    const sessionCode = this.state.oldSessionCode;

    API.post('/?action=getSession&code=' + encodeURIComponent(sessionCode) )
      .then((response) => {
        console.log(response);
        if (response.data) {
          Player.setCookie('sessionID', sessionCode, 1);
          this.setState({
            fireRedirect: true
          });
        } else {
          let errors = {};
          errors['oldSession'] = 'De volgende inlogcode "'+ sessionCode +'" is niet in gebruik!';
          this.setState({
            formErrorsResume: errors,
            showErrorResume: true,
          })
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  handleSubmit = e => {
    e.preventDefault();
    Player.storeData('playerEmail', this.state.mail_adres);
    Player.storeData('sessionCode', this.state.sessionCode);

    const user = {
      name: this.state.mail_adres,
      roundLengths: this.state.time_distribution,
      playerCount: this.state.player_distribution,
      sessionCode: this.state.sessionCode,
      className: this.state.className,
    };

    if (this.handleValidation(user)) {
      // Send a POST request
      API.post('/?action=createSession', {
        className: user.className,
        emailAddress: user.name,
        code: user.sessionCode,
        roundLengths: user.roundLengths,
        playerCount: user.playerCount
      })
      .then(function (response) {
        //console.log(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });

      Player.setCookie('sessionID', user.sessionCode, 1);
      Player.storeData('sessionWasRestored', true);

      this.setState({
        fireRedirect: true
      });
    } else {
      return null;
    }
  }

  changeVal = (field, amount) => {
    if (field === "player") {
      const newVal = this.state.playerAmount + amount

      if (newVal < 14) {
        return;
      } else if (newVal > 36) {
        return;
      } else {

        const data = playerDistributionArray[newVal-14];

        Player.storeData('playerAmount', data);
        this.setState({
          playerAmount: newVal,
          player_distribution: data,
        });

      }

    } else if(field === "duration") {
      const newVal = this.state.duration + amount;

      if (newVal < 80) {
        return;
      } else if (newVal > 130) {
        return;
      } else {

        const index = (newVal -80) / 5;
        const data = timeDistributionArray[index];
        console.log("Selected", data);
        Player.storeData('gameTime', data);
        this.setState({
          duration: newVal,
          time_distribution: data
        });
      }
    }
  }

  handleChange = (e) => {
    const target = e.target
    const name = target.name
    const value = target.type === 'checkbox' ? target.checked : target.value

    if (name === 'class_name') {
      this.setState({
        className: value
      });
    } else if (name === 'mail_adres') {
      this.setState({
        mail_adres: value
      });
    } else {
      console.log('Error at: ', e);
    }
    if (this.state.className && this.state.mail_adres) {
      this.setState({
        mainButtonActive: true,
      })
    }
  }

  componentWillMount() {
    // Setting default round to 1
    let startRound = parseInt(1, 10);
    Player.storeData('round', startRound);

    // Setting current route for next redirect
    var currentLocation = this.props.location.pathname;
    Player.storeData('localRoute', currentLocation);

    // Check if cookie isset
    let cookie = Player.getCookie('sessionID')
    if (cookie) {
      this.setState({
        fireRedirect: true
      });
    }
    // Gett- setting new settingcode.
    API.post('/?action=createSessionCode')
    .then((response) => {
      this.setState({
        sessionCode: response.data.code
      });
      //console.log(response);
    })
    .catch(function (error) {
      console.log(error);
    });

  }

  // Render of object
  _renderObject(errors){
		return Object.entries(errors).map(([key, value], i) => {
			return (
				<li key={key}>
					{value}
				</li>
			)
		})
  }

  render() {
    return (
      <Page pageTitle='Start'>
        <div className="playerRegistrationForm">
          <form autoComplete="off">
            <h2>Nieuw spel</h2>
            <span>Wil je een nieuw spel starten? Vul dan hieronder je gegevens in. </span>
            <div className="disclaimer">Het e-mail adres wordt alleen gebruikt om de inlogcode te sturen. <a target="_blank" rel="noopener noreferrer" href="https://youvegotthepower.nl/footer/privacystatement">(Privacystatement)</a></div>
            <div className="label">
              <label>Naam van de klas</label>
              <input type="text" name="class_name" onChange={this.handleChange} placeholder="Klasnaam"/>
            </div>

            <div className="label">
              <label>Inlogcode</label>
              <input type="text" value={this.state.sessionCode} readOnly />
            </div>

            <input id="fakemail" style={{display: "none"}} type="email" name="fake-email" />

            <div className="label">
              <label>Email</label>
              <input name="mail_adres" type="email" value={this.state.mail_adres} onChange={this.handleChange} placeholder="Email" autoComplete='nope'/>
            </div>

            <div className="label">
              <label>Hoe lang wil je spelen? </label>
              <div className="custom-input">
                <input readOnly className="custom-num" name='time_distribution' type='text'  value={this.state.duration + ' minuten'}/>
                <div onClick={() => this.changeVal("duration", -5)} className="formModifier formModifier--desc"></div>
                <div onClick={() => this.changeVal("duration", 5)} className="formModifier formModifier--asc"></div>
              </div>
            </div>

            <div className="label">
              <label>Hoeveel spelers zijn er? </label>
              <div className="custom-input">
                <input readOnly className="custom-num" name='player_distribution' type='text' value={this.state.playerAmount + ' leerlingen'}/>
                <div onClick={() => this.changeVal("player", -1)} className="formModifier formModifier--desc"></div>
                <div onClick={() => this.changeVal("player", 1)} className="formModifier formModifier--asc"></div>
              </div>
            </div>

            <div className="pageLink">
              <a target="_blank" rel="noopener noreferrer" href="https://youvegotthepower.nl/files/pdf/instructiebladen.pdf">Download instructiebladen met spelregels (pdf)</a>
            </div>
            <div className="pageLink">
              <a target="_blank" rel="noopener noreferrer" href="https://youvegotthepower.nl/files/pdf/paspoort.pdf">Download leerlingenpaspoort (pdf)</a>
            </div>
            <div className="pageLink">
              <a target="_blank" rel="noopener noreferrer" href="https://youvegotthepower.nl/files/pdf/naambordjes.pdf">Download naambadges (pdf)</a>
            </div>

            {this.state.showError &&
            <div className="error-message">
              <span>Er ging iets mis!</span>
              <ul>
              {this._renderObject(this.state.formErrors)}
              </ul>
            </div>}

            <div className="label">
              <input disabled={!this.state.mainButtonActive} type="button" value="Start spel!" onClick={this.handleSubmit} />
            </div>
          </form>

          <form autoComplete="off" className="form-resume">
            <h2>Verder spelen</h2>
            <span>Verder spelen met een bestaand spel? Vul hier je inlogcode in.</span>
            <div className="label">
              <label>Inlogcode</label>
              <input type="text" placeholder="Inlogcode" onChange={this.handleCodeChange} value={this.state.oldSessionCode} />
            </div>

            {this.state.showErrorResume &&
            <div className="error-message">
              <span>Er ging iets mis!</span>
              <ul>
              {this._renderObject(this.state.formErrorsResume)}
              </ul>
            </div>}

            <div className="label">
              <input disabled={!this.state.oldSessionCode} type="button" value="Speel verder!" onClick={this.handleResume} />
            </div>
          </form>
          {this.state.fireRedirect && (<Redirect to="/intro"/>)}
        </div>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/playerRegistration.js